export default __webpack_public_path__ + "static/media/learose3-1440w.c5d91cad.webp";